import "./index.css";

import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import styles from './style.module.css';
 //import IconProvider from "../IconProvider";
 //import { ARROW_DOWN_BOLD , arrowTop, ic_circle_close} from "../../../assets/index";

import { CSSTransition } from 'react-transition-group';
//import Typography from "../Typography";
import uuid from 'uuid-random';
import IconProvider from "../../design-system/lib/IconProvider";
import { arrowTop, ic_circle_close } from "../../assets";
import Typography from "../../design-system/lib/Typography";
import TextareaAutosize from 'react-textarea-autosize';


const CustomField_MultiLine = ({
  containerStyle ,
  error, IconComponents , pretitle, handleIsOpen, hint, closeIcon, noArrowIcon = false, inputType, checkSelected = "hybrid", onChange, clearOnClick, clearText, data, placement, text, badgeText, title, style, className, value, onClick, size, icon, isSelected, isRequired, requiredText, textStyle } ) => {
    const [isOpen, setIsOpen] = useState(false);
  const [focus, setFocus] = useState(false);

    const [elmId, setElmId] = useState(`"elmDrop${uuid()}`);
    const [mapZindex, setMapZindex] = useState(0);

    //  useEffect(() => {
    //      setTimeout(() => {
    //         try {
    //               const element = document.getElementById('googlemapUniqeId');
    //               setMapZindex(element.style.zIndex)
    //         } catch (error) {
    //         }
    //      }, 1000);
    //     }, []);
    

    const dropdownNode  = useClickOutside(() => {
        setIsOpen(false);
    })

    const getParentWidth = React.useCallback(() => {

        let elm = document.getElementById(elmId)
        var box = elm.getBoundingClientRect();

        return box.width
        
      }, [elmId ]);

    useEffect(() => {

   try {
         if (handleIsOpen) {
             handleIsOpen(isOpen)
         }
 
 
   } catch (error) {
    
   }
    }, [isOpen]);


    const openEditCustomer = React.useCallback(() => {



        if(placement == "topStart"){
            let elm = document.getElementById(elmId)
   
            var body = document.body,
            html = document.documentElement;

            var height = Math.max( body.scrollHeight, body.offsetHeight, 
                                html.clientHeight, html.scrollHeight, html.offsetHeight );


            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var bottom  = height -  box.y
            var left = box.left 

            console.log("dwvefewsdxs ",body.clientHeight , box.y)

 
            return {bottom: `${Math.round(bottom)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

        }else if(placement == "topEnd"){
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top 
            var left = box.left + scrollLeft - clientLeft;
 
 
            return  {top: `${Math.round(top)}px`, right : `${Math.round(clientRight)}px`};

         
        }else if(placement == "bottomStart"){
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top +  box.height + 10;
            var left = box.left + scrollLeft - clientLeft;
 
 
            return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
       
        }else if(placement == "bottomEnd"){
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top +  box.height + 10;
            var left = box.left + scrollLeft - clientLeft;
 
 
            return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
        }else{
            let elm = document.getElementById(elmId)
   
            var box = elm.getBoundingClientRect();
    
            var body = document.body;
            var docEl = document.documentElement;
        
            var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
            var clientTop = docEl.clientTop || body.clientTop || 0;
            var clientLeft = docEl.clientLeft || body.clientLeft || 0;
            var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
            var top  = box.top  
            var left = box.left 
 
            return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

        }


        
      }, [elmId , placement]);

  
 
    //    useEffect(() => { 
    
        
    //     if(mapZindex != 0){
      
    //  try {
    //         if (isOpen) {
    //             const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = String(Number(mapZindex) - 1);
    //          } else {
    //        const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = mapZindex;
    //          }
    //      } catch (error) {
    //      }
    // }
        
    //      }, [isOpen]);

    // const openEditCustomer = React.useCallback(() => {


    //     if(placement == "topStart"){
    //         let elm = document.getElementById(elmId)
   
    //         var body = document.body,
    //         html = document.documentElement;

    //         var height = Math.max( body.scrollHeight, body.offsetHeight, 
    //                             html.clientHeight, html.scrollHeight, html.offsetHeight );


    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var bottom  = height -  box.y
    //         var left = box.left 

    //         console.log("dwvefewsdxs ",body.clientHeight , box.y)

 
    //         return {bottom: `${Math.round(bottom)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

    //     }else if(placement == "topEnd"){
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top 
    //         var left = box.left + scrollLeft - clientLeft;
 
 
    //         return  {top: `${Math.round(top)}px`, right : `${Math.round(clientRight)}px`};

         
    //     }else if(placement == "bottomStart"){
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top +  box.height + 10;
    //         var left = box.left + scrollLeft - clientLeft;
 
 
    //         return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
       
    //     }else if(placement == "bottomEnd"){
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top +  box.height + 10;
    //         var left = box.left + scrollLeft - clientLeft;
 
 
    //         return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(box.left)}px`)};
    //     }else{
    //         let elm = document.getElementById(elmId)
   
    //         var box = elm.getBoundingClientRect();
    
    //         var body = document.body;
    //         var docEl = document.documentElement;
        
    //         var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    //         var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        
    //         var clientTop = docEl.clientTop || body.clientTop || 0;
    //         var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    //         var clientRight = ((docEl.clientWidth || body.clientWidth) - box.width - box.left) || 0;
 
 
        
    //         var top  = box.top  
    //         var left = box.left 
 
    //         return {top: `${Math.round(top)}px`, [clientRight <= 200 ? "right" :"left"] :  (clientRight <= 200 ? `${Math.round(clientRight)}px` : `${Math.round(left)}px`)};

    //     }


        
    //   }, [elmId , placement]);

  
 
    //    useEffect(() => { 
    
        
    //     if(mapZindex != 0){
      
    //  try {
    //         if (isOpen) {
    //             const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = String(Number(mapZindex) - 1);
    //          } else {
    //        const element = document.getElementById('googlemapUniqeId');
    //            element.style.zIndex = mapZindex;
    //          }
    //      } catch (error) {
    //      }
    // }
        
    //      }, [isOpen]);
    

    return (
            <div className={clsx(styles.containerStyle )} style={containerStyle && containerStyle}> 
        
            <div id={elmId} onClick={(e) => { setIsOpen(!isOpen) }} className={clsx(styles.tiny , className && className , focus && styles.focus)}
            style={style ? style : {}} >

            {(IconComponents) && IconComponents}

            {(icon) && <IconProvider Icon={icon} size="14" />}
            {/* <input placeholder={hint} type={inputType} onChange={onChange} /> */}
            <TextareaAutosize  placeholder={hint} type={inputType} onChange={(e)=>{ console.log("fsdfds " ,e) ;onChange(e) ;  ; setFocus(true) }} value={value} 
                onFocus={() => { setFocus(true) }} onBlur={() => { setFocus(false) }} 
          onClick={() => { setFocus(true) }} 
            />

                {(text && pretitle) && <span className={clsx(styles.title , textStyle && textStyle )} >
              { (closeIcon && isSelected) && <IconProvider Icon={ic_circle_close} size="14" onClick={(e) => {
                  e.stopPropagation();
                  clearOnClick && clearOnClick()
                  // setCurrentValue(null);
                  // onChange(null)
                }} />}
                 {pretitle && <> <span style={{fontWeight:"400" , color:"rgba(72, 72, 72, 1)" ,marginInlineEnd:"-3px"}}> {pretitle} | </span>{text}</>}
                 {(isRequired && !isSelected) && <span className={styles.isRequired}> * </span>}
                {(badgeText) && <span className={styles.isRequired}> {badgeText} </span>}

            </span>}


            {(data && data.length > 0 && !noArrowIcon ) && <IconProvider Icon={arrowTop} size="14" style={{ width: "14px", height: "14px",transform:"rotate(180deg)" }} />}

        </div>
    
    { error && <span className={styles.error}> {error} </span>}
    
      </div>

         
      

    );
};

export default CustomField_MultiLine;



const useClickOutside = (handler) => {
    const domNode = useRef();
    useEffect(() => {
       try {
         const eventHandler = (event) => {
             if (!domNode?.current?.contains(event.target)) {
                 handler();
             }
             // uncomment this for dropdown close on menu click
             // handler();
         }
         document.addEventListener("mousedown", eventHandler);
         return () => {
             document.removeEventListener('mousedown', eventHandler);
         }
       } catch (error) {
        
       }
    });
    return domNode;
}